// shared/pdf/components/PdfSummaryCards.jsx
import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  row:    { flexDirection: 'row', gap: 8, marginBottom: 10 },
  card:   { flex: 1, borderRadius: 4, padding: 10, borderLeftWidth: 3 },
  label:  { fontSize: 7, fontFamily: 'NotoSans', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 4 },
  value:  { fontSize: 12, fontFamily: 'NotoSans', fontWeight: 'bold' },
});

// items: [{ label, value, color? }]
export default function PdfSummaryCards({ items, theme }) {
  return (
    <View style={styles.row}>
      {items.map((item, i) => (
        <View key={i} style={[styles.card, { backgroundColor: theme.light, borderLeftColor: item.color || theme.titleText }]}>
          <Text style={[styles.label, { color: theme.muted }]}>{item.label}</Text>
          <Text style={[styles.value, { color: item.color || theme.body }]}>{item.value}</Text>
        </View>
      ))}
    </View>
  );
}
